/* tslint:disable */
/* eslint-disable */
/**
 * Hisselab.SmartScreens.Query
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Any
 */
export interface Any {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof Any
     */
    '@type': string;
}
/**
 * 
 * @export
 * @interface ConstituentInfo
 */
export interface ConstituentInfo {
    /**
     * 
     * @type {string}
     * @memberof ConstituentInfo
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConstituentInfo
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface ConstituentReplay
 */
export interface ConstituentReplay {
    /**
     * 
     * @type {Array<ConstituentInfo>}
     * @memberof ConstituentReplay
     */
    'Items'?: Array<ConstituentInfo>;
    /**
     * 
     * @type {string}
     * @memberof ConstituentReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface FetchReplay
 */
export interface FetchReplay {
    /**
     * 
     * @type {Array<Snapshot>}
     * @memberof FetchReplay
     */
    'Items'?: Array<Snapshot>;
    /**
     * 
     * @type {string}
     * @memberof FetchReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface FieldData
 */
export interface FieldData {
    /**
     * 
     * @type {string}
     * @memberof FieldData
     */
    'Id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldData
     */
    'Name'?: string;
    /**
     * 
     * @type {number}
     * @memberof FieldData
     */
    'Value'?: number;
}
/**
 * 
 * @export
 * @interface ScoreData
 */
export interface ScoreData {
    /**
     * 
     * @type {number}
     * @memberof ScoreData
     */
    'fieldId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ScoreData
     */
    'fieldName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScoreData
     */
    'code'?: string;
    /**
     * 
     * @type {number}
     * @memberof ScoreData
     */
    'score'?: number;
    /**
     * 
     * @type {number}
     * @memberof ScoreData
     */
    'average'?: number;
    /**
     * 
     * @type {number}
     * @memberof ScoreData
     */
    'last'?: number;
    /**
     * 
     * @type {number}
     * @memberof ScoreData
     */
    'max'?: number;
    /**
     * 
     * @type {number}
     * @memberof ScoreData
     */
    'min'?: number;
}
/**
 * 
 * @export
 * @interface Snapshot
 */
export interface Snapshot {
    /**
     * 
     * @type {string}
     * @memberof Snapshot
     */
    'entityId'?: string;
    /**
     * 
     * @type {number}
     * @memberof Snapshot
     */
    'sourceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof Snapshot
     */
    'securityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Snapshot
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof Snapshot
     */
    'uniqueCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof Snapshot
     */
    'name'?: string;
    /**
     * 
     * @type {Array<ScoreData>}
     * @memberof Snapshot
     */
    'indicators'?: Array<ScoreData>;
    /**
     * 
     * @type {Array<FieldData>}
     * @memberof Snapshot
     */
    'fields'?: Array<FieldData>;
}
/**
 * 
 * @export
 * @interface StandoutCategoryInfo
 */
export interface StandoutCategoryInfo {
    /**
     * 
     * @type {string}
     * @memberof StandoutCategoryInfo
     */
    'name'?: string;
    /**
     * 
     * @type {Array<StandoutInfo>}
     * @memberof StandoutCategoryInfo
     */
    'items'?: Array<StandoutInfo>;
}
/**
 * 
 * @export
 * @interface StandoutCategoryListReplay
 */
export interface StandoutCategoryListReplay {
    /**
     * 
     * @type {Array<StandoutCategoryInfo>}
     * @memberof StandoutCategoryListReplay
     */
    'Items'?: Array<StandoutCategoryInfo>;
    /**
     * 
     * @type {string}
     * @memberof StandoutCategoryListReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface StandoutGridColumnInfo
 */
export interface StandoutGridColumnInfo {
    /**
     * 
     * @type {string}
     * @memberof StandoutGridColumnInfo
     */
    'binding'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandoutGridColumnInfo
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface StandoutGridInfo
 */
export interface StandoutGridInfo {
    /**
     * 
     * @type {Array<StandoutGridColumnInfo>}
     * @memberof StandoutGridInfo
     */
    'columns'?: Array<StandoutGridColumnInfo>;
}
/**
 * 
 * @export
 * @interface StandoutInfo
 */
export interface StandoutInfo {
    /**
     * 
     * @type {number}
     * @memberof StandoutInfo
     */
    'dataId'?: number;
    /**
     * 
     * @type {string}
     * @memberof StandoutInfo
     */
    'name'?: string;
    /**
     * 
     * @type {StandoutGridInfo}
     * @memberof StandoutInfo
     */
    'grid'?: StandoutGridInfo;
}
/**
 * 
 * @export
 * @interface Status
 */
export interface Status {
    /**
     * 
     * @type {number}
     * @memberof Status
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    'message'?: string;
    /**
     * 
     * @type {Array<Any>}
     * @memberof Status
     */
    'details'?: Array<Any>;
}

/**
 * DashboardServiceApi - axios parameter creator
 * @export
 */
export const DashboardServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardCategorylistGet: async (identityToken: string, culture?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('dashboardCategorylistGet', 'identityToken', identityToken)
            const localVarPath = `/dashboard/categorylist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardConstituentsGet: async (identityToken: string, culture?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('dashboardConstituentsGet', 'identityToken', identityToken)
            const localVarPath = `/dashboard/constituents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardServiceApi - functional programming interface
 * @export
 */
export const DashboardServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardCategorylistGet(identityToken: string, culture?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StandoutCategoryListReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardCategorylistGet(identityToken, culture, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardConstituentsGet(identityToken: string, culture?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConstituentReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardConstituentsGet(identityToken, culture, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DashboardServiceApi - factory interface
 * @export
 */
export const DashboardServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardCategorylistGet(identityToken: string, culture?: string, options?: any): AxiosPromise<StandoutCategoryListReplay> {
            return localVarFp.dashboardCategorylistGet(identityToken, culture, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardConstituentsGet(identityToken: string, culture?: string, options?: any): AxiosPromise<ConstituentReplay> {
            return localVarFp.dashboardConstituentsGet(identityToken, culture, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardServiceApi - object-oriented interface
 * @export
 * @class DashboardServiceApi
 * @extends {BaseAPI}
 */
export class DashboardServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [culture] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public dashboardCategorylistGet(identityToken: string, culture?: string, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).dashboardCategorylistGet(identityToken, culture, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [culture] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public dashboardConstituentsGet(identityToken: string, culture?: string, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).dashboardConstituentsGet(identityToken, culture, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QueryServiceApi - axios parameter creator
 * @export
 */
export const QueryServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [constituentEntityId] 
         * @param {number} [standoutId] 
         * @param {number} [currencyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smartscreenFetchdataGet: async (identityToken: string, culture?: string, constituentEntityId?: string, standoutId?: number, currencyId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('smartscreenFetchdataGet', 'identityToken', identityToken)
            const localVarPath = `/smartscreen/fetchdata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (constituentEntityId !== undefined) {
                localVarQueryParameter['constituentEntityId'] = constituentEntityId;
            }

            if (standoutId !== undefined) {
                localVarQueryParameter['standoutId'] = standoutId;
            }

            if (currencyId !== undefined) {
                localVarQueryParameter['currencyId'] = currencyId;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QueryServiceApi - functional programming interface
 * @export
 */
export const QueryServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QueryServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [constituentEntityId] 
         * @param {number} [standoutId] 
         * @param {number} [currencyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async smartscreenFetchdataGet(identityToken: string, culture?: string, constituentEntityId?: string, standoutId?: number, currencyId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.smartscreenFetchdataGet(identityToken, culture, constituentEntityId, standoutId, currencyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * QueryServiceApi - factory interface
 * @export
 */
export const QueryServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QueryServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {string} [constituentEntityId] 
         * @param {number} [standoutId] 
         * @param {number} [currencyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smartscreenFetchdataGet(identityToken: string, culture?: string, constituentEntityId?: string, standoutId?: number, currencyId?: number, options?: any): AxiosPromise<FetchReplay> {
            return localVarFp.smartscreenFetchdataGet(identityToken, culture, constituentEntityId, standoutId, currencyId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QueryServiceApi - object-oriented interface
 * @export
 * @class QueryServiceApi
 * @extends {BaseAPI}
 */
export class QueryServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [culture] 
     * @param {string} [constituentEntityId] 
     * @param {number} [standoutId] 
     * @param {number} [currencyId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryServiceApi
     */
    public smartscreenFetchdataGet(identityToken: string, culture?: string, constituentEntityId?: string, standoutId?: number, currencyId?: number, options?: AxiosRequestConfig) {
        return QueryServiceApiFp(this.configuration).smartscreenFetchdataGet(identityToken, culture, constituentEntityId, standoutId, currencyId, options).then((request) => request(this.axios, this.basePath));
    }
}



